import React, { useRef } from 'react';
interface TiltedCardProps {
  children: ReactNode;
  className?: string;
  maxTilt?: number;
  scale?: number;
  glare?: boolean;
}
export function TiltedCard({
  children,
  className = '',
  maxTilt = 8,
  scale = 1.02,
  glare = true
}: TiltedCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const glareRef = useRef<HTMLDivElement>(null);
  const handleMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const rx = (y - cy) / cy * -maxTilt;
    const ry = (x - cx) / cx * maxTilt;
    ref.current.style.transform = `perspective(1000px) rotateX(${rx}deg) rotateY(${ry}deg) scale3d(${scale}, ${scale}, ${scale})`;
    if (glareRef.current) {
      const px = x / rect.width * 100;
      const py = y / rect.height * 100;
      glareRef.current.style.background = `radial-gradient(circle at ${px}% ${py}%, rgba(26,143,212,0.25) 0%, transparent 50%)`;
      glareRef.current.style.opacity = '1';
    }
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)';
    if (glareRef.current) glareRef.current.style.opacity = '0';
  };
  return <div ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave} className={`relative transition-transform duration-200 ease-out ${className}`} style={{
    transformStyle: 'preserve-3d',
    willChange: 'transform'
  }} data-id="element-259">
      {children}
      {glare && <div ref={glareRef} className="absolute inset-0 pointer-events-none rounded-[inherit] opacity-0 transition-opacity duration-200" style={{
      mixBlendMode: 'screen'
    }} data-id="element-260" />}
    </div>;
}